import { ConfirmationDialog } from '../../shared/confirmation-dialog';
import { L } from 'harmony-language';
import React, { FC } from 'react';
import { useDeleteLoadsMutation } from '../../../api/mutations/reworked/delete/use-delete-loads-mutation';
import { Load } from '../../../types';
import { useDraftsLoadsContext } from '../drafts-loads-context';

interface DeleteLoadsModalProps {
    open: boolean;
    records: Load[];
    unselectFn: () => void;
    onResultCallback: () => void;
}

export const DeleteLoadsModal: FC<DeleteLoadsModalProps> = (props) => {
    const { open, records, unselectFn, onResultCallback } = props;
    const { isDrafts } = useDraftsLoadsContext();
    const { mutate: deleteLoads } = useDeleteLoadsMutation(isDrafts);

    return (
        <ConfirmationDialog
            open={open}
            title={L.deleteConfirmationTitle()}
            message={L.deleteConfirmationMessage(`${records.length} ${L.loads().toLocaleLowerCase()}`)}
            cancelText={L.cancel()}
            confirmText={L.delete()}
            resultCallback={async (confirmed) => {
                onResultCallback();
                if (confirmed) {
                    unselectFn();
                    deleteLoads({ ids: records.map(x => x.id) });
                }
            }}>
        </ConfirmationDialog>
    );
};
